// Gender

document.getElementById("gender").addEventListener("change", function (event) {
	var value = event.target.value;
	[].forEach.call(document.getElementsByClassName("female-question"), function (element) {
		if (value == "F")
			element.classList.remove("d-none");
		else
			element.classList.add("d-none");
	});
});
document.getElementById("gender").dispatchEvent(new Event("change"));

// Species

[].forEach.call(document.querySelectorAll("label[data-alternate]"), function (element) {
	element.dataset.primary = element.textContent;
});

setSpecies(document.getElementById("species").value);

document.getElementById("species").addEventListener("change", function (event) {
	setSpecies(event.target.value);
});

function setSpecies(species)
{
	if (species == "Human") {
		[].forEach.call(document.querySelectorAll("label[data-primary]"), function (element) {
			element.textContent = element.dataset.primary;
		});
		[].forEach.call(document.getElementsByClassName("human-question"), function (element) {
			element.classList.remove("d-none");
		});
		[].forEach.call(document.getElementsByClassName("pet-question"), function (element) {
			element.classList.add("d-none")
		});
	}
	else {
		[].forEach.call(document.querySelectorAll("label[data-alternate]"), function (element) {
			element.textContent = element.dataset.alternate;
		});
		[].forEach.call(document.getElementsByClassName("human-question"), function (element) {
			element.classList.add("d-none");
		});
		[].forEach.call(document.getElementsByClassName("pet-question"), function (element) {
			element.classList.remove("d-none")
		});
	}
}
